module.exports = "/_next/static/images/dash-41c7334d45244fce8c5fed16f9da1749.svg";